// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"89":"7c1a5103","163":"607eb6bd","383":"9c98c7da"}[chunkId] + ".js";
};